<template>
  <section class="section">
    <div class="container py-6" :class="$style.showTopSeparator">
      <div
        class="columns has-text-centered is-vcentered"
        :class="$style.showSeparator"
      >
        <div class="column">
          <h2 style="margin: 0;" class="title has-text-centered">
            Empresas que confían en nosotros
          </h2>
          <div class="columns">
            <div class="column" v-for="partner in data" :key="partner.name">
              <img style="max-width: 60%;" :src="partner.logo" alt="logo" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Partner",
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" module>
.showTopSeparator {
  border-top: 1px solid #d0d0d0;
}

.showSeparator {
  border-bottom: 1px solid #d0d0d0;
}
</style>
